import {
    ROUTE_NAME,
} from '@/lib/constant';

export default [
    // 成为队长咨询
    {
        path: '/consult',
        name: ROUTE_NAME.CONSULT,
        meta: {
            title: '咨询',
        },
        component: () => import('@/pages/extra/consult.vue'),
    },
    // 当前报名的百日跑
    {
        path: '/activity/current',
        name: ROUTE_NAME.ACTIVITY_CURRENT,
        meta: {
            title: '',
        },
        redirect() {
            return {
                name: ROUTE_NAME.ACTIVITY,
                params: {
                    activityId: '1',
                },
            };
        },
    },
];
